const ROOT_URI = '/agent/commissions';

export default {
  COMMISSIONS: `${ROOT_URI}`,
  COMMISSION_SCHEDULES: `${ROOT_URI}/schedules`,
  COMMISSIONS_API: (version: string) => `/api/policies/v${version}/correspondences/get`
};
